import { connect } from "react-redux";
import moment from "moment";

import { PazienError } from "common/helpers/errors";
import { FETCH_BATCH_TRANSACTIONS } from "common/actions/reconciliation";

import { BaseTable } from "../analytics/common/transactions/transactionsTable";

const mapStateToProps = (state) => ({
    date_range: state.common.date_range,
    table_configs: state.components.table_configs.transactions,
    transferStatus: state.reconciliation.transferStatus,
    section: state.reconciliation.section,
    filters: state.reconciliation.filters
});

export const DrilldownTable = connect(mapStateToProps)(class extends BaseTable {
    componentDidMount() {
        if (this.props.section === "all") {
            this.setState({
                hasError: true,
                error: new PazienError({ message: "Unsupported section value: <all>" })
            });
            return null;
        }
        this.fetchTableConfig();
        this.fetchData();
        return null;
    }

    componentDidUpdate(prevProps) {
        if (this.props.section !== prevProps.section) {
            this.fetchTableConfig();
            this.fetchData();
        }
        this.adjustDatatable();
    }

    fetchTableConfig = () => {
        const { table_configs, section } = this.props;
        const config = table_configs?.user?.[section] || table_configs?.pazien?.[section];
        if (config) {
            this.setState({ config }, this.setTableUI);
        } else {
            const error = new Error("Table configs did not load");
            this.setState({ hasError: true, error: { error, capture: true } });
        }
    };

    fetchData = (options = {}) => {
        this.setState({ isLoading: true });
        this.cleanPromises();
        const promise = FETCH_BATCH_TRANSACTIONS({
            section: this.props.section,
            limit: 100,
            page: this.state.page,
            start: this.props.date_range.startDate,
            end: this.props.date_range.endDate,
            status: this.props.transferStatus,
            q: this.props.filters,
            ...options
        }).then(
            ({ results, ...rest }) => {
                this.setState({
                    isLoading: false, data: results, ...rest
                });
                return results;
            }
        ).catch(this.catchFetchErrors);

        this.promises.push(promise);
        return promise;
    };

    getExportOptions = () => {
        const filters = {
            start: this.props.date_range.startDate || "",
            end: this.props.date_range.endDate || "",
            status: this.props.transferStatus,
            datetype: "settlement",
            q: this.props.filters
        };
        
        const totalTxns = this.state.count;
        
        return {
            filters,
            resource: "transactions_fisc_recon_v3",
            section: this.props.section,
            status: this.props.transferStatus,
            formats: [
                {
                    active: true,
                    value: "csv",
                    label: "CSV"
                },
                {
                    active: totalTxns === null || totalTxns < 1_048_576,
                    value: "xlsx",
                    label: "XLSX"
                }
            ],
            suggested_name: `${this.props.suggestedNamePrefix}_txns_${moment(filters.start).format("YYYYMMDD")}-${moment(filters.end).format("YYYYMMDD")}`
        };
    };
});
